import React, { useContext } from "react";
import { ModalContext } from "../../context/ModalContext";

const SuccessAlert = () => {
  const { showSuccess, successContent, clearSuccess } =
    useContext(ModalContext);

  return (
    <div
      className={`alert alert-success alert-dismissible fixed-top ms-auto me-2 fade-show ${
        !showSuccess ? "hidden" : ""
      }`}
      role="alert"
      style={{
        maxWidth: 500,
        zIndex: 2500,
        // Keep clear of the device safe area (notch / Dynamic Island).
        marginTop: "calc(env(safe-area-inset-top, 0px) + 16px)",
      }}
    >
      {successContent}
      <button className="btn btn-sm text-muted" onClick={clearSuccess}>
        <i className="fa fa-times"></i>
      </button>
    </div>
  );
};

export default SuccessAlert;
